import * as React from "react";
import { ShapeStyles } from "../../../../types";
import { getShapeStyle } from "../../shared";
import { getHexagonIndicatorPathTDSnapshot, getHexagonPath } from "../hexagonHelpers";

interface HexagonSvgProps {
  id: string;
  size: number[];
  style: ShapeStyles;
  isSelected: boolean;
  isDarkMode: boolean;
}

export const DrawHexagon = React.memo(function DrawHexagon({
  id,
  size,
  style,
  isSelected,
  isDarkMode,
}: HexagonSvgProps) {
  const { stroke, strokeWidth, fill } = getShapeStyle(style, isDarkMode);
  const pathTDSnapshot = getHexagonPath(id, size, style);
  const indicatorPath = getHexagonIndicatorPathTDSnapshot(id, size, style);
  return (
    <>
      <path className={style.isFilled || isSelected ? "tl-fill-hitarea" : "tl-stroke-hitarea"} d={indicatorPath} />
      {style.isFilled && <path d={indicatorPath} fill={fill} pointerEvents="none" />}
      <path d={pathTDSnapshot} fill={stroke} stroke={stroke} strokeWidth={strokeWidth} pointerEvents="none" />
    </>
  );
});
